/* Upload Your Own (sections/digital-upload.liquid), step 2.
   When the photo is low resolution, the "Image Resolution Upscaler" toggle moves from under
   "Next: Choose frame" to the top of the options column, with a short label and note, and stands in
   for the underlined "try Image Resolution Upscaler" link under the photo and the "Want it bigger?"
   banner (both hidden while it is up there). High-resolution photos keep the page as it was.

   "Low resolution" = what the page itself already decided: the upscaler suggestion under the photo
   is showing, or the "Want it bigger?" banner is (upscaling would unlock a greyed-out size), or the
   upscaler is on. Once a photo qualifies it stays at the top for that photo, so the column does not
   jump while the shopper tries sizes.

   Loop-safe: the observer watches the suggestion line (style/class), the banners (hidden), the toggle
   box (style) and the status text; this script writes only the box's position, its note, the label
   and one class on #dp-step-2 - none of which it observes. */
(function () {
  if (window.smwUpscaleTop) return;
  window.smwUpscaleTop = true;

  var step = document.getElementById('dp-step-2');
  var box = document.getElementById('enhanceImageBtnWrap');
  var left = step && step.querySelector('.size-left');
  if (!step || !box || !left) return;

  var home = box.nextElementSibling; // .enhance-modal: where the box goes back to
  var claid = document.getElementById('claidImageEnahance');
  var cb = document.getElementById('enhanceImageBtnWrap1');
  var statusEl = box.querySelector('.enhance-status');
  var content = box.querySelector('.enhance-content');

  var css = document.createElement('style');
  css.textContent =
    '.smw-up-top{margin:0 0 22px}.smw-up-top[hidden]{display:none}' +
    '#dp-step-2.smw-up-is-top .enhance-box{margin-top:0;background:#f5f3ef;border:1.5px solid #111}' +
    '#dp-step-2.smw-up-is-top .enhance-content>p:nth-of-type(2){display:none}#dp-step-2.smw-up-is-top .enhance-content{padding-right:10px}' +
    '.smw-up-note{display:none}' +
    '#dp-step-2.smw-up-is-top .enhance-content .smw-up-note{display:block;margin-top:3px;font-size:13px;line-height:1.35;color:#1e1e1e}' +
    '#dp-step-2.smw-up-is-top #claidImageEnahance .upscale-option-wrap{display:none!important}' +
    '#dp-step-2.smw-up-is-top .smw-unlock{display:none!important}';
  document.head.appendChild(css);

  var wrap = document.createElement('div');
  wrap.className = 'smw-up-top';
  wrap.hidden = true;
  wrap.innerHTML = '<span class="smw-adj-eyebrow"></span>';
  var label = wrap.firstChild;
  left.insertBefore(wrap, left.firstChild);

  var note = document.createElement('p');
  note.className = 'smw-up-note';
  if (content) content.appendChild(note);

  var flagged = new WeakSet();
  var watched = new WeakSet();
  var raf = 0;

  function shown(el) { return !!el && !el.classList.contains('hide') && el.style.display !== 'none'; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function update() {
    raf = 0;
    var st = null;
    try { st = activeImageId ? imagesState[activeImageId] : null; } catch (e) {}

    var suggest = shown(claid) && shown(claid && claid.querySelector('.upscale-option-wrap'));
    var unlock = false;
    document.querySelectorAll('.smw-unlock').forEach(function (el) { if (!el.hidden) unlock = true; });
    var status = statusEl ? statusEl.textContent.trim() : '';
    var on = !!(cb && cb.checked) || status === 'Enabled' || status === 'Processing...';

    if (st && (suggest || unlock || on)) flagged.add(st);
    var top = !!st && flagged.has(st) && box.style.display !== 'none';

    if (top) {
      if (box.parentNode !== wrap) wrap.appendChild(box);
      if (status === 'Enabled') {
        setText(label, 'Upscaled photo');
        setText(note, 'Switch off to use your original photo.');
      } else if (status === 'Processing...') {
        if (!label.textContent) setText(label, 'Low resolution photo');
        setText(note, 'Upscaling your photo...');
      } else {
        setText(label, suggest ? 'Low resolution photo' : 'Unlock bigger sizes');
        setText(note, unlock ? 'Switch on to sharpen your photo and unlock bigger sizes.'
                             : 'Switch on to sharpen your photo for a crisper print.');
      }
    } else if (box.parentNode === wrap) {
      if (home && home.parentNode === left) left.insertBefore(box, home);
      else left.appendChild(box);
    }
    if (wrap.hidden === top) wrap.hidden = !top;
    if (step.classList.contains('smw-up-is-top') !== top) step.classList.toggle('smw-up-is-top', top);
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  var mo = new MutationObserver(schedule);
  function watch(el, opts) { if (el && !watched.has(el)) { watched.add(el); mo.observe(el, opts); } }
  function attach() {
    watch(claid, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
    watch(box, { attributes: true, attributeFilter: ['style'] });
    watch(statusEl, { childList: true, characterData: true, subtree: true });
    document.querySelectorAll('.smw-unlock').forEach(function (el) { watch(el, { attributes: true, attributeFilter: ['hidden'] }); });
  }

  // The banners are created and refreshed whenever a photo is measured or the size list is rebuilt.
  if (window.smwUnlock && typeof window.smwUnlock.refresh === 'function') {
    var orig = window.smwUnlock.refresh;
    window.smwUnlock.refresh = function () {
      var r = orig.apply(this, arguments);
      attach();
      schedule();
      return r;
    };
  }
  // Thumbnail switches, toggle clicks and the upscale pop-ups settle on timers.
  document.addEventListener('click', function () { setTimeout(schedule, 400); }, true);
  if (cb) cb.addEventListener('change', schedule);

  attach();
  schedule();
})();
